<template>
<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <line x1="6.35" y1="0.5625" x2="6.35" y2="19.3125" stroke="black" stroke-width="1.2"/>
  <path d="M14 13L11 10L14 7" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  <rect x="0.6" y="0.6" width="19.8" height="18.8" rx="4.4" stroke="black" stroke-width="1.2"/>
</svg>
</template>